/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetFrontAmbitiParams,
  WsRispostaPaginataListAmbitoDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco degli ambiti
 * @summary Elenco Ambiti
 */
export const getFrontAmbiti = (
  params?: GetFrontAmbitiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListAmbitoDTO>(
    { url: `/framework-cmp-domande/ambiti`, method: 'get', params, signal },
    options,
  );
};

export const getGetFrontAmbitiQueryKey = (params?: GetFrontAmbitiParams) =>
  [`/framework-cmp-domande/ambiti`, ...(params ? [params] : [])] as const;

export const getGetFrontAmbitiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontAmbiti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontAmbitiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontAmbiti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontAmbiti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFrontAmbitiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFrontAmbiti>>> = ({
    signal,
  }) => getFrontAmbiti(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontAmbitiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontAmbiti>>
>;
export type GetFrontAmbitiQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Ambiti
 */
export const useGetFrontAmbiti = <
  TData = Awaited<ReturnType<typeof getFrontAmbiti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontAmbitiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontAmbiti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontAmbitiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
